import { render, staticRenderFns } from "./InnerShadowRIcon.vue?vue&type=template&id=c7425be8&"
import script from "./InnerShadowRIcon.vue?vue&type=script&lang=js&"
export * from "./InnerShadowRIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports